// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av {
  display: flex;
  padding: 16px 24px;
  height: 100%;
  gap: 20px;
  background: #f5f5f5;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__sider--g4a2l {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 24px;
  width: 250px;
  overflow: auto;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu {
  background: transparent;
  border-inline-end: none;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item {
  position: relative;
  height: auto;
  line-height: 22px;
  margin: 0;
  padding: 12px 0;
  border-radius: 0;
  color: rgba(0, 0, 0, 0.88);
  width: 100%;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item::after {
  display: none;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item:hover,
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item:active {
  background: transparent;
  color: rgba(0, 0, 0, 0.88);
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item-selected {
  background: transparent !important;
  color: rgba(0, 0, 0, 0.88) !important;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item-selected:hover {
  background: transparent !important;
  color: rgba(0, 0, 0, 0.88) !important;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item-selected::after {
  display: none;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP.ant-menu .ant-menu-item-selected::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #e43d00;
}
.src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av .src-businessServices-services-bsChat-ChatListPage-module__content--zDqrR {
  flex: 1;
  padding: 10px 24px;
  background: white;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsChat/ChatListPage.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;AACF;AANA;EAQI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;AACJ;AAdA;EAgBI,uBAAA;EACA,uBAAA;AACJ;AAlBA;EAoBM,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,WAAA;AACN;AACM;EACE,aAAA;AACR;AAEM;;EAEE,uBAAA;EACA,0BAAA;AAAR;AApCA;EAyCM,kCAAA;EACA,qCAAA;AAFN;AAIM;EACE,kCAAA;EACA,qCAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAMM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAJR;AAxDA;EAiEI,OAAA;EACA,kBAAA;EACA,iBAAA;AANJ","sourcesContent":[".layout {\n  display: flex;\n  padding: 16px 24px;\n  height: 100%;\n  gap: 20px;\n  background: #f5f5f5;\n\n  .sider {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding-top: 24px;\n    width: 250px;\n    overflow: auto;\n  }\n  .chatMenu:global(.ant-menu) {\n    background: transparent;\n    border-inline-end: none;\n\n    :global(.ant-menu-item) {\n      position: relative;\n      height: auto;\n      line-height: 22px;\n      margin: 0;\n      padding: 12px 0;\n      border-radius: 0;\n      color: rgba(0, 0, 0, 0.88);\n      width: 100%;\n\n      &::after {\n        display: none;\n      }\n\n      &:hover,\n      &:active {\n        background: transparent;\n        color: rgba(0, 0, 0, 0.88);\n      }\n    }\n\n    :global(.ant-menu-item-selected) {\n      background: transparent !important;\n      color: rgba(0, 0, 0, 0.88) !important;\n\n      &:hover {\n        background: transparent !important;\n        color: rgba(0, 0, 0, 0.88) !important;\n      }\n\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        width: 2px;\n        background: #e43d00;\n      }\n    }\n  }\n  .content {\n    flex: 1;\n    padding: 10px 24px;\n    background: white;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `src-businessServices-services-bsChat-ChatListPage-module__layout--tk8Av`,
	"sider": `src-businessServices-services-bsChat-ChatListPage-module__sider--g4a2l`,
	"chatMenu": `src-businessServices-services-bsChat-ChatListPage-module__chatMenu--ZLBZP`,
	"content": `src-businessServices-services-bsChat-ChatListPage-module__content--zDqrR`
};
export default ___CSS_LOADER_EXPORT___;
